<script setup>
const props = defineProps({
  isOverlayOpen: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:isOverlayOpen'])
const config = useRuntimeConfig()

const LINK_MAP = {
  river: '/onebox/river/',
  radar: '/onebox/radar/',
  wind: '/onebox/wind/',
  satellite: '/onebox/satellite/',
  chart: '/onebox/chart/',
  opinion: '/opinion/',
  report: '/report/'
}

const handleToggle = () => {
  emit('update:isOverlayOpen', !props.isOverlayOpen)
}

const onClickButton = (category) => {
  if (category === 'livecam') {
    emit('update:isOverlayOpen', false)
    return
  }
  const path = LINK_MAP[category]
  const url = category === 'report' ? `https://wxrepo.weathernews.jp${path}` : `${config.public.hostDomain}${path}`
  return navigateTo(url, { external: true })
}

const buttonList = [
  { category: 'livecam', label: 'ライブカメラ' },
  { category: 'river', label: '河川水位' },
  { category: 'radar', label: '雨雲レーダー' },
  { category: 'wind', label: '風レーダー' },
  { category: 'satellite', label: '気象衛星' },
  { category: 'chart', label: '天気図' },
  { category: 'opinion', label: '長期予報' },
  { category: 'report', label: 'リポート' }
]
</script>

<template>
  <MiOOverlay
    :data-showed="props.isOverlayOpen"
    :class="{ active: props.isOverlayOpen }"
    @click.self="handleToggle()"
  >
    <MiMOverlayBlock
      data-position="right"
      data-style="border"
      :style="{ transform: 'translateX(0)' }"
    >
      <div>
        <MiARadarButton
          v-for="({ category, label }) in buttonList"
          :key="category"
        >
          <RadarLinkButton
            :category="category"
            :label="label"
            @click="onClickButton(category)"
          />
        </MiARadarButton>
      </div>
      <MiACloseButton data-type="circle">
        <button aria-label="メニューを閉じる" @click="handleToggle()" />
      </MiACloseButton>
    </MiMOverlayBlock>
  </MiOOverlay>
</template>

<style lang="scss" scoped>
</style>
